<p>Type customer's host URL (for example, trustcenter-yev.anecdotes.dev)</p>
<input type="text" [(ngModel)]="customerUrl"/>
<button (click)="setCustomer()">Set customer</button>
